module.exports = __webpack_public_path__ + "img/pic-boy.33a3450.svg";